(function() {
  'use strict';

    $('#backtotop').on('click', function (e) {
      e.preventDefault();
      var self = this;
      $(this).addClass('fly');
      setTimeout(function(){
        $('html,body').animate({
          scrollTop: 0
        }, 700, function(){
          $(self).removeClass('fly');
        });
      }, 100);
    });

})();
